"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _autoBind = _interopRequireDefault(require("auto-bind"));

var _marshaler = _interopRequireDefault(require("../util/marshaler"));

var _apiKeys = _interopRequireDefault(require("./api-keys"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var Users = /*#__PURE__*/function () {
  function Users(registry) {
    (0, _classCallCheck2["default"])(this, Users);
    this._api = registry;
    this.ApiKeys = new _apiKeys["default"](registry.UserAccess, {
      parentRoutes: {
        get: 'user_ids.user_id',
        list: 'user_ids.user_id',
        create: 'user_ids.user_id',
        update: 'user_ids.user_id'
      }
    });
    (0, _autoBind["default"])(this);
  }

  (0, _createClass2["default"])(Users, [{
    key: "_addState",
    value: function _addState(fieldMask, user) {
      // Ensure to set STATE_REQUESTED if needed, which gets stripped as null
      // value from the backend response.
      if (fieldMask && fieldMask.field_mask.paths.includes('state') && !('state' in user)) {
        user.state = 'STATE_REQUESTED';
      }

      return user;
    }
  }, {
    key: "getAll",
    value: function () {
      var _getAll = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(params, selector) {
        var _this = this;

        var fieldMask, response, users;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                fieldMask = _marshaler["default"].selectorToFieldMask(selector);
                _context.next = 3;
                return this._api.UserRegistry.List(undefined, _objectSpread(_objectSpread({}, params), fieldMask));

              case 3:
                response = _context.sent;
                users = _marshaler["default"].payloadListResponse('users', response);
                users.users.map(function (user) {
                  return _this._addState(fieldMask, user);
                });
                return _context.abrupt("return", users);

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getAll(_x, _x2) {
        return _getAll.apply(this, arguments);
      }

      return getAll;
    }()
  }, {
    key: "search",
    value: function () {
      var _search = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(params, selector) {
        var _this2 = this;

        var fieldMask, response, users;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                fieldMask = _marshaler["default"].selectorToFieldMask(selector);
                _context2.next = 3;
                return this._api.EntityRegistrySearch.SearchUsers(undefined, _objectSpread(_objectSpread({}, params), fieldMask));

              case 3:
                response = _context2.sent;
                users = _marshaler["default"].payloadListResponse('users', response);
                users.users.map(function (user) {
                  return _this2._addState(fieldMask, user);
                });
                return _context2.abrupt("return", users);

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function search(_x3, _x4) {
        return _search.apply(this, arguments);
      }

      return search;
    }()
  }, {
    key: "getById",
    value: function () {
      var _getById = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(id, selector) {
        var fieldMask, response, user;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                fieldMask = _marshaler["default"].selectorToFieldMask(selector);
                _context3.next = 3;
                return this._api.UserRegistry.Get({
                  routeParams: {
                    'user_ids.user_id': id
                  }
                }, fieldMask);

              case 3:
                response = _context3.sent;
                user = this._addState(fieldMask, _marshaler["default"].payloadSingleResponse(response));
                return _context3.abrupt("return", user);

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getById(_x5, _x6) {
        return _getById.apply(this, arguments);
      }

      return getById;
    }()
  }, {
    key: "deleteById",
    value: function () {
      var _deleteById = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(id) {
        var response;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this._api.UserRegistry.Delete({
                  routeParams: {
                    user_id: id
                  }
                });

              case 2:
                response = _context4.sent;
                return _context4.abrupt("return", _marshaler["default"].payloadSingleResponse(response));

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function deleteById(_x7) {
        return _deleteById.apply(this, arguments);
      }

      return deleteById;
    }()
  }, {
    key: "purgeById",
    value: function () {
      var _purgeById = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(id) {
        var response;
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this._api.UserRegistry.Purge({
                  routeParams: {
                    user_id: id
                  }
                });

              case 2:
                response = _context5.sent;
                return _context5.abrupt("return", _marshaler["default"].payloadSingleResponse(response));

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function purgeById(_x8) {
        return _purgeById.apply(this, arguments);
      }

      return purgeById;
    }()
  }, {
    key: "restoreById",
    value: function () {
      var _restoreById = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6(id) {
        var response;
        return _regenerator["default"].wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this._api.UserRegistry.Restore({
                  routeParams: {
                    user_id: id
                  }
                });

              case 2:
                response = _context6.sent;
                return _context6.abrupt("return", _marshaler["default"].payloadSingleResponse(response));

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function restoreById(_x9) {
        return _restoreById.apply(this, arguments);
      }

      return restoreById;
    }()
  }, {
    key: "updateById",
    value: function () {
      var _updateById = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7(id, patch) {
        var mask,
            response,
            result,
            user,
            _result,
            _args7 = arguments;

        return _regenerator["default"].wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                mask = _args7.length > 2 && _args7[2] !== undefined ? _args7[2] : _marshaler["default"].fieldMaskFromPatch(patch);
                _context7.next = 3;
                return this._api.UserRegistry.Update({
                  routeParams: {
                    'user.ids.user_id': id
                  }
                }, {
                  user: patch,
                  field_mask: _marshaler["default"].fieldMask(mask)
                });

              case 3:
                response = _context7.sent;
                result = _marshaler["default"].unwrapUser(response); // Get new profile picture value if a new picture was uploaded, deleted, or
                // the primary email address was changed (in case of Gravar usage).

                if (!(mask.includes('profile_picture') || mask.includes('primary_email_address'))) {
                  _context7.next = 11;
                  break;
                }

                _context7.next = 8;
                return this.getById(id, ['profile_picture']);

              case 8:
                user = _context7.sent;
                _result = _marshaler["default"].unwrapUser(response);
                _result.profile_picture = user.profile_picture;

              case 11:
                return _context7.abrupt("return", result);

              case 12:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function updateById(_x10, _x11) {
        return _updateById.apply(this, arguments);
      }

      return updateById;
    }()
  }, {
    key: "create",
    value: function () {
      var _create = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee8(user, invitationToken) {
        var response;
        return _regenerator["default"].wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return this._api.UserRegistry.Create(undefined, {
                  user: user,
                  invitation_token: invitationToken
                });

              case 2:
                response = _context8.sent;
                return _context8.abrupt("return", _marshaler["default"].unwrapUser(response));

              case 4:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function create(_x12, _x13) {
        return _create.apply(this, arguments);
      }

      return create;
    }() // Miscellaneous.

  }, {
    key: "getRightsById",
    value: function () {
      var _getRightsById = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee9(userId) {
        var result;
        return _regenerator["default"].wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return this._api.UserAccess.ListRights({
                  routeParams: {
                    user_id: userId
                  }
                });

              case 2:
                result = _context9.sent;
                return _context9.abrupt("return", _marshaler["default"].unwrapRights(result));

              case 4:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function getRightsById(_x14) {
        return _getRightsById.apply(this, arguments);
      }

      return getRightsById;
    }()
  }, {
    key: "updatePasswordById",
    value: function updatePasswordById(id, payload) {
      return this._api.UserRegistry.UpdatePassword({
        routeParams: {
          'user_ids.user_id': id
        }
      }, {
        "new": payload["new"],
        old: payload.old,
        revoke_all_access: payload.revoke_all_access
      });
    }
  }, {
    key: "createTemporaryPassword",
    value: function createTemporaryPassword(id) {
      return this._api.UserRegistry.CreateTemporaryPassword({
        routeParams: {
          'user_ids.user_id': id
        }
      });
    } // Invitations.

  }, {
    key: "sendInvite",
    value: function () {
      var _sendInvite = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee10(email) {
        var response;
        return _regenerator["default"].wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return this._api.UserInvitationRegistry.Send(undefined, email);

              case 2:
                response = _context10.sent;
                return _context10.abrupt("return", _marshaler["default"].unwrapInvitation(response));

              case 4:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function sendInvite(_x15) {
        return _sendInvite.apply(this, arguments);
      }

      return sendInvite;
    }()
  }, {
    key: "getAllInvitations",
    value: function () {
      var _getAllInvitations = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee11(params, selector) {
        var _this3 = this;

        var fieldMask, result, invitations;
        return _regenerator["default"].wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                fieldMask = _marshaler["default"].selectorToFieldMask(selector);
                _context11.next = 3;
                return this._api.UserInvitationRegistry.List(undefined, _objectSpread(_objectSpread({}, params), fieldMask));

              case 3:
                result = _context11.sent;
                invitations = _marshaler["default"].payloadListResponse('invitations', result);
                invitations.invitations.map(function (i) {
                  return _this3._addState(fieldMask, i);
                });
                return _context11.abrupt("return", invitations);

              case 7:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function getAllInvitations(_x16, _x17) {
        return _getAllInvitations.apply(this, arguments);
      }

      return getAllInvitations;
    }()
  }, {
    key: "deleteInvite",
    value: function () {
      var _deleteInvite = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee12(email) {
        var response;
        return _regenerator["default"].wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.next = 2;
                return this._api.UserInvitationRegistry.Delete(undefined, email);

              case 2:
                response = _context12.sent;
                return _context12.abrupt("return", _marshaler["default"].unwrapInvitation(response));

              case 4:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function deleteInvite(_x18) {
        return _deleteInvite.apply(this, arguments);
      }

      return deleteInvite;
    }()
  }]);
  return Users;
}();

var _default = Users;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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